import ChipFilter from "./ChipFilter";

export default ChipFilter;